import React from 'react'
import { Link } from 'react-router-dom';

function Futuro22() {
  
    return (
        <div className=' font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/Multideck" className="block py-1 pl-4 hover:underline mt-6">Multideck -</Link>
           <span className="block py-1 pl-4 mt-6">FUTURO 2</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/futunew.jpg" alt="Vista" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">FUTURO 2</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">Compact vertical displays for modern retail.</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">Designed for all modern grocery store formats, the Futuro serve-over counters line is reborn with extended and beneficial features like improved energy efficiency, integral refrigeration system, broad display tray and in three widths. More product sales opportunities that go together with the ease of cleaning to facilitate daily operations and grant the perfect hygiene.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">
       <p className="text-xl lg:text-2xl opacity-90">Meat, Charcuterie and Cheese<span className=' text-blue-400'>-1… +4 °C</span> (3M0)</p>

    </div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
           <p className="text-xl lg:text-2xl text-lime-500 text-center">R290</p>
         </div>

         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 md:pt-32">
            {/* case 1 */}
             <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl lg:text-4xl">High performance and greater energy savings</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>Ventilated cooling system that guarantees perfect and uniform temperature distribution throughout the display - temperature class 3M0.</div>
    <ul className="list-[square] list-outside text-gray-500">
  <li className="text-xl font-thin opacity-90 mt-6">
  Front glass with passive anti-condensation system with low energy consumption.
  </li>
  <li className="text-xl font-thin opacity-90 mt-6">
  Defrosting system by ventilation and compressor stop 2H/2H without resistance or hot gas.
  </li>
  <li className="text-xl font-thin opacity-90 mt-6">
  Double-glazed side glasses for greater energy efficiency.
  </li>
  <li className="text-xl font-thin opacity-90 mt-6">
  Solar thermometer, no batteries, no maintenance, no costs.
  </li>
</ul>

    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>High performance, low energy consumption, visibility and low noise for the best shopping experience.</div>

</div>

                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/futocase.jpg" className="max-w-full h-auto object-contain" />
               </div>
             </div>
    
            {/* case 2 */}
             <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/futocase1.jpg" className="max-w-full h-auto object-contain" />
               </div>
    
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl lg:text-4xl">Two models according to your business needs</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>Designed to improve daily cleaning operations and increase display capacity, Futuro 2 serve-overs are available in two models</div>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>Models with a vertical evaporator (EV) under the worktop, which guarantees greater protection, reduces the accumulation of residues and makes cleaning easier.</div>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>Models with a horizontal evaporator (EH) under the worktop, giving 80+ mm depth for your products.</div>
</div>
             </div>

              {/* case 3 */}
              <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               
    
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl lg:text-4xl">Different display capacities for your business</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>Available in widths of 105, 115 and 125 cm, the large 220 mm maximum loading height display provides high capacity for your products, always with the best conservation conditions.</div>

</div>
  {/* ✅ Image Wrapper */}
  <div className="w-full md:w-1/2">
                 <img src="/images/futocase2.gif" className="max-w-full h-auto object-contain" />
               </div>
             </div>
         </div>
    
    {/* card & description */}
    <div className="flex flex-wrap gap-6 justify-center">
  {[
    {
      img: "images/futocard.jpg",
      text: "Plug-in models or for remote condensing unit installation.",
    },
    {
      img: "images/futocard1.gif",
      text: "Optimized product presentation, tiltable display trays.",
    },
    {
      img: "images/prescard6.gif",
      text: "Built-in multimedia LED displays for a better shopping experience and promotion in store.",
    },
    {
      img: "images/futocard3.gif",
      text: "4 front glass options vertical flat glass (VPV) vertical flat glass self-service (VPV-LS) tilted flat glass (VPI) tilted flat glass self-service (VPI-LS)",
    },
  ].map((item, index) => (
    <div key={index} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/5 flex flex-col items-center mb-6">
      <div>
        <img className="w-full max-w-[20rem]" src={item.img} alt="Card Image" />
      </div>
      <div className="mt-4 text-center text-xl font-thin text-gray-500 max-w-sm">
        {item.text}
      </div>
    </div>
  ))}
</div>

<h1 className='text-3xl text-center pt-12'>Uncomplicated care and maintenance</h1>
<h2  className='text-xl text-center'>Details that simplify cleaning and reduce the maintenance attention of your display.</h2>
<div className='flex flex-col md:flex-row justify-center gap-12 mt-12'>

<div  className="w-full sm:w-1/2 md:w-1/3 lg:w-1/3 flex flex-col items-center mb-6">

      <div>
        <img className="w-full max-w-[20rem]" src='/images/futocard3.jpg' alt="Card Image" />
      </div>
      <div className="mt-4  text-xl font-thin text-gray-500 max-w-sm">
       <p>Auxiliary cleaning system with water jets that facilitates the daily display's hygienisation, minimizes the contamination risks and helps save time and money.</p>
      </div>
    </div>

    <div  className="w-full sm:w-1/2 md:w-1/3 lg:w-1/3 flex flex-col items-center mb-6">

      <div>
        <img className="w-full max-w-[20rem]" src='/images/futocard4.jpg' alt="Card Image" />
      </div>
      <div className="mt-4  text-xl  font-thin text-gray-500 max-w-sm">
       <p>Models with a rotating fan drawer, allowing easy access and cleaning of the entire bottom of the display.</p>
      </div>
    </div>

    <div  className="w-full sm:w-1/2 md:w-1/3 lg:w-1/3 flex flex-col items-center mb-6">

      <div>
        <img className="w-full max-w-[20rem]" src='/images/futocard5.jpg' alt="Card Image" />
      </div>
      <div className="mt-4  text-xl font-thin text-gray-500 max-w-sm">
       
      <ul className="list-[square] list-outside text-gray-500">
  <li className="text-xl font-thin opacity-90 mt-6">
  Solid and robust construction, stainless steel interiors.
  </li>
  <li className="text-xl font-thin opacity-90 mt-6">
  Stainless steel worktop.
  </li>
  <li className="text-xl font-thin opacity-90 mt-6">
  Magnetic cover for easy access to the condensing unit.
  </li>
  <li className="text-xl font-thin opacity-90 mt-6">
  Wide front glass opening for easy access.
  </li>
  <li className="text-xl font-thin opacity-90 mt-6">
  Valve for draining liquids.
  </li>
</ul>
      </div>
    </div>
</div>

     </div>
    
  
        </div>
      )
    }

export default Futuro22